import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import __ from "src/utils/Translations";
import { FC } from "react";

interface UnsavedChangesModalProps {
  showModal: boolean;
  handleCancelLeave: () => void;
  handleConfirmLeave: () => void;
  message?: string;
}

const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  showModal,
  handleCancelLeave,
  handleConfirmLeave,
  message,
}) => (
  <Modal isOpen={showModal} toggle={handleCancelLeave}>
    <ModalHeader toggle={handleCancelLeave}>
      {__("Czy na pewno chcesz opuścić tę stronę?")}
    </ModalHeader>
    <ModalBody>
      {message ||
        __(
          "Masz niezapisane zmiany w tej zakładce. Czy na pewno chcesz opuścić tę zakładkę? Niezapisane zmiany zostaną utracone."
        )}
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={handleCancelLeave}>
        {__("Nie")}
      </Button>
      <Button color="primary" onClick={handleConfirmLeave}>
        {__("Tak")}
      </Button>
    </ModalFooter>
  </Modal>
);

export default UnsavedChangesModal;
